import React from 'react';

import { GroupBase } from 'react-select-5';
import ReactAsyncSelect, { AsyncProps } from 'react-select-5/async';
import ReactBaseSelect from 'react-select-5/base';

import { getClassNames, getComponents } from './Select/helpers';
import s from './Select/index.module.css';
import { TSelectMeta } from './Select/types';

type TProps<Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>> = Partial<
  AsyncProps<Option, IsMulti, Group>
> &
  TSelectMeta;

type TAsyncSelect = <Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>(
  props: TProps<Option, IsMulti, Group> & React.RefAttributes<ReactBaseSelect<Option, IsMulti, Group>>,
) => JSX.Element;

const _AsyncSelect = function <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  { classNames, components, ...props }: TProps<Option, IsMulti, Group>,
  ref: React.Ref<ReactBaseSelect<Option, IsMulti, Group>> = null,
) {
  return (
    <ReactAsyncSelect<Option, IsMulti, Group>
      ref={ref}
      unstyled
      openMenuOnFocus
      className={s.base}
      components={getComponents({ ...props, components })}
      classNames={getClassNames({ ...props, classNames })}
      {...props}
    />
  );
};

// forwardRef broke type inference
export const AsyncSelect = React.forwardRef(_AsyncSelect) as TAsyncSelect;
